import { faClock, faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import {
  faCheckCircle,
  faInfoCircle,
  faX,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { So5LineupImportState } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  status: So5LineupImportState;
};

const getLabelColor = (status: So5LineupImportState) => {
  switch (status) {
    case So5LineupImportState.PROCESSED:
      return 'var(--c-green-400)';
    case So5LineupImportState.PROCESSING:
      return 'var(--c-white)';
    case So5LineupImportState.FAILED:
    case So5LineupImportState.EXPIRED:
      return 'var(--c-red-400)';
    default:
      return 'var(--c-nd-600)';
  }
};

const getLabelContent = (status: So5LineupImportState) => {
  switch (status) {
    case So5LineupImportState.PREPARED:
    case So5LineupImportState.PREPARING:
      return (
        <>
          <FontAwesomeIcon icon={faClock} />
          <FormattedMessage {...glossary.ready} />
        </>
      );
    case So5LineupImportState.PROCESSING:
      return <LoadingIndicator smaller />;
    case So5LineupImportState.PROCESSED:
      return (
        <>
          <FontAwesomeIcon icon={faCheckCircle} />
          <FormattedMessage {...glossary.done} />
        </>
      );
    case So5LineupImportState.DECLINED:
      return (
        <>
          <FontAwesomeIcon icon={faX} />
          <FormattedMessage {...glossary.declined} />
        </>
      );
    case So5LineupImportState.FAILED:
      return (
        <>
          <FontAwesomeIcon icon={faInfoCircle} />
          <FormattedMessage {...glossary.failed} />
        </>
      );
    case So5LineupImportState.EXPIRED:
      return (
        <>
          <FontAwesomeIcon icon={faClockRotateLeft} />
          <FormattedMessage {...glossary.expired} />
        </>
      );
    default:
      return null;
  }
};

export const LineupImportStatus = ({ status }: Props) => {
  return (
    <LabelS color={getLabelColor(status)}>
      <Horizontal as="span">{getLabelContent(status)}</Horizontal>
    </LabelS>
  );
};
